import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useEffect, useState, forwardRef, useRef, useContext } from 'react';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { V2CriticalIcon, CriticalAltIcon, V2CheckmarkBackgroundIcon, CheckCircleAltIcon } from '@paypalcorp/pp-react-icons';
import clsx from 'clsx';
import { useTheme } from '@paypalcorp/pp-react-theme';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { IntlContext, getFormattedMessage } from '@paypalcorp/pp-react-intl';
import '../__generated__/styles/text-input.css';

var styles = {"ppvx_text-input__label":"ppvx_text-input__label___3-14-6","ppvx_text-input__label--screenreader":"ppvx_text-input__label--screenreader___3-14-6","ppvx_text-input__helper-text":"ppvx_text-input__helper-text___3-14-6","ppvx_text-input":"ppvx_text-input___3-14-6","ppvx_text-input__icon--right":"ppvx_text-input__icon--right___3-14-6","ppvx_text-input__icon--left":"ppvx_text-input__icon--left___3-14-6","ppvx_text-input--layerfix":"ppvx_text-input--layerfix___3-14-6","ppvx_text-input__placemat":"ppvx_text-input__placemat___3-14-6","ppvx_text-input__control":"ppvx_text-input__control___3-14-6","ppvx_text-input--nolabel":"ppvx_text-input--nolabel___3-14-6","ppvx_field--error":"ppvx_field--error___3-14-6","ppvx_combo--open":"ppvx_combo--open___3-14-6","ppvx_text-input--combine-right":"ppvx_text-input--combine-right___3-14-6","ppvx_text-input--combine-both":"ppvx_text-input--combine-both___3-14-6","ppvx_text-input__prefix-wrapper":"ppvx_text-input__prefix-wrapper___3-14-6","ppvx_text-input__prefix-wrapper--focus":"ppvx_text-input__prefix-wrapper--focus___3-14-6","ppvx_text-input__control--icon-right":"ppvx_text-input__control--icon-right___3-14-6","ppvx_text-input--combine-left":"ppvx_text-input--combine-left___3-14-6","ppvx_text-input--permafocus":"ppvx_text-input--permafocus___3-14-6","ppvx_combo":"ppvx_combo___3-14-6","ppvx_text-input__error-text":"ppvx_text-input__error-text___3-14-6","ppvx_text-input__error-icon":"ppvx_text-input__error-icon___3-14-6","ppvx_text-input__success-icon":"ppvx_text-input__success-icon___3-14-6","ppvx_text-input__error-text--list":"ppvx_text-input__error-text--list___3-14-6","ppvx_text-input__prefix":"ppvx_text-input__prefix___3-14-6","ppvx_text-input__suffix":"ppvx_text-input__suffix___3-14-6","ppvx_text-input__control--prefix":"ppvx_text-input__control--prefix___3-14-6","ppvx_text-input__control--suffix":"ppvx_text-input__control--suffix___3-14-6","ppvx_text-input__error-text--with-svg-icon":"ppvx_text-input__error-text--with-svg-icon___3-14-6","ppvx--v2":"ppvx--v2___3-14-6","ppvx--v1":"ppvx--v1___3-14-6","ppvx_text-input--auto-grow":"ppvx_text-input--auto-grow___3-14-6","ppvx_text-input__counter-wrapper":"ppvx_text-input__counter-wrapper___3-14-6","ppvx_text-input__counter-text":"ppvx_text-input__counter-text___3-14-6","ppvx_text-input__counter-wrapper--focus":"ppvx_text-input__counter-wrapper--focus___3-14-6","ppvx_screenreader":"ppvx_screenreader___3-14-6","ppvx_body--no-scrolling":"ppvx_body--no-scrolling___3-14-6","ppvx_visible-only-in-context":"ppvx_visible-only-in-context___3-14-6","ppvx_text-ellipsis":"ppvx_text-ellipsis___3-14-6","ppvx_text-input-display":"ppvx_text-input-display___3-14-6","ppvx_text-input-display__control":"ppvx_text-input-display__control___3-14-6","ppvx_text-input-display__label":"ppvx_text-input-display__label___3-14-6","ppvx_text-input-display__wrapper":"ppvx_text-input-display__wrapper___3-14-6"};

var _excluded = ["setFocus", "className", "inputClassName", "labelClassName", "successText", "successIconAriaLabel", "errorText", "error", "errorIconAriaLabel", "helperText", "value", "name", "id", "label", "isLabelHidden", "multiline", "placeholder", "placemat", "leftIcon", "rightIcon", "onChange", "children", "renderContent", "removeBorderRadiusLeft", "removeBorderRadiusRight", "removeBorderRadiusBoth", "dir", "theme"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var FormMessage = function (_ref) {
  var messageId = _ref.messageId,
      helperText = _ref.helperText,
      errorText = _ref.errorText,
      errorIconAriaLabel = _ref.errorIconAriaLabel,
      successText = _ref.successText,
      successIconAriaLabel = _ref.successIconAriaLabel,
      theme = _ref.theme;

  // errorText takes higher priority over helperText
  if (errorText || successText) {
    var _errorIcon;

    var text = errorText ? errorText : successText;
    var processText = Array.isArray(text) ? /*#__PURE__*/React.createElement("ul", {
      className: styles['ppvx_text-input__error-text--list']
    }, text.map(function (msg, index) {
      return /*#__PURE__*/React.createElement("li", {
        key: "msg".concat(messageId, "-").concat(index)
      }, msg);
    })) : text;
    var errorIcon, successIcon;

    if (errorText) {
      var errorProps = {
        className: styles['ppvx_text-input__error-icon'],
        role: 'img',
        'aria-label': errorIconAriaLabel
      };
      errorIcon = theme === 'v2' ? /*#__PURE__*/React.createElement(V2CriticalIcon, _extends({
        size: "sm"
      }, errorProps)) : /*#__PURE__*/React.createElement(CriticalAltIcon, _extends({
        size: "xs"
      }, errorProps));
    }

    if (!errorText) {
      var successProps = {
        className: styles['ppvx_text-input__success-icon'],
        role: 'img',
        'aria-label': successIconAriaLabel
      };
      successIcon = theme === 'v2' ? /*#__PURE__*/React.createElement(V2CheckmarkBackgroundIcon, _extends({
        size: "sm"
      }, successProps)) : /*#__PURE__*/React.createElement(CheckCircleAltIcon, _extends({
        size: "xs"
      }, successProps));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: clsx(styles['ppvx_text-input__error-text'], styles['ppvx_text-input__error-text--with-svg-icon']),
      id: messageId,
      role: "alert"
    }, (_errorIcon = errorIcon) !== null && _errorIcon !== void 0 ? _errorIcon : successIcon, processText);
  }

  if (helperText) {
    var _processText = Array.isArray(helperText) ? /*#__PURE__*/React.createElement("ul", {
      className: styles['ppvx_text-input__helper-text'],
      id: messageId
    }, helperText.map(function (msg, index) {
      return /*#__PURE__*/React.createElement("li", {
        key: "msg".concat(messageId, "-").concat(index)
      }, msg);
    })) : /*#__PURE__*/React.createElement("div", {
      className: styles['ppvx_text-input__helper-text'],
      id: messageId
    }, helperText);

    return _processText;
  }

  return null;
};

var renderIcon = function (icon, side) {
  return icon ? React.cloneElement(icon, {
    className: clsx(icon.props.className, styles["ppvx_text-input__icon--".concat(side)])
  }) : null;
};

var TextInputWrapper = function (_ref2) {
  var _clsx;

  var setFocus = _ref2.setFocus,
      className = _ref2.className,
      inputClassName = _ref2.inputClassName,
      labelClassName = _ref2.labelClassName,
      successText = _ref2.successText,
      _ref2$successIconAria = _ref2.successIconAriaLabel,
      successIconAriaLabel = _ref2$successIconAria === void 0 ? 'Success' : _ref2$successIconAria,
      errorText = _ref2.errorText,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? !!errorText : _ref2$error,
      _ref2$errorIconAriaLa = _ref2.errorIconAriaLabel,
      errorIconAriaLabel = _ref2$errorIconAriaLa === void 0 ? 'Error' : _ref2$errorIconAriaLa,
      helperText = _ref2.helperText,
      value = _ref2.value,
      name = _ref2.name,
      _ref2$id = _ref2.id,
      id = _ref2$id === void 0 ? "text-input-".concat(name) : _ref2$id,
      label = _ref2.label,
      isLabelHidden = _ref2.isLabelHidden,
      _ref2$multiline = _ref2.multiline,
      multiline = _ref2$multiline === void 0 ? false : _ref2$multiline,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? ' ' : _ref2$placeholder,
      placemat = _ref2.placemat,
      _ref2$leftIcon = _ref2.leftIcon,
      leftIcon = _ref2$leftIcon === void 0 ? null : _ref2$leftIcon,
      _ref2$rightIcon = _ref2.rightIcon,
      rightIcon = _ref2$rightIcon === void 0 ? null : _ref2$rightIcon,
      onChange = _ref2.onChange,
      children = _ref2.children,
      renderContent = _ref2.renderContent,
      removeBorderRadiusLeft = _ref2.removeBorderRadiusLeft,
      removeBorderRadiusRight = _ref2.removeBorderRadiusRight,
      removeBorderRadiusBoth = _ref2.removeBorderRadiusBoth,
      dir = _ref2.dir,
      theme = _ref2.theme,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var _theme = useTheme('TextInput', theme);

  var InputTag = multiline ? 'textarea' : 'input';
  var mainClasses = clsx(styles['ppvx_text-input'], (_clsx = {}, _defineProperty(_clsx, styles['ppvx_field--error'], error), _defineProperty(_clsx, styles['ppvx_text-input--nolabel'], !label || label === '' || isLabelHidden), _defineProperty(_clsx, styles['ppvx_text-input--textarea'], multiline), _defineProperty(_clsx, styles['ppvx_text-input--combine-left'], removeBorderRadiusLeft), _defineProperty(_clsx, styles['ppvx_text-input--combine-right'], removeBorderRadiusRight), _defineProperty(_clsx, styles['ppvx_text-input--combine-both'], removeBorderRadiusBoth), _defineProperty(_clsx, styles['ppvx--v2'], _theme === 'v2'), _clsx), className);
  var inputTagClasses = clsx(styles['ppvx_text-input__control'], _defineProperty({}, styles['ppvx_text-input__control--icon-right'], rightIcon), inputClassName);
  var labelClasses = clsx(styles['ppvx_text-input__label'], labelClassName);
  var msgId = "message_".concat(id);
  var valueProps = onChange ? {
    onChange: onChange,
    value: value
  } : {
    defaultValue: value
  };
  var ariaDescribedByProp = helperText || errorText ? {
    'aria-describedby': msgId
  } : {};

  var otherProps = _objectSpread(_objectSpread(_objectSpread({}, ariaDescribedByProp), valueProps), rest);

  return /*#__PURE__*/React.createElement("div", {
    className: mainClasses,
    dir: dir
  }, renderIcon(leftIcon, 'left'), renderContent(_objectSpread({
    inputClassName: inputTagClasses,
    name: name,
    id: id,
    setFocus: setFocus,
    hasError: error,
    placeholder: placeholder,
    placemat: placemat,
    label: label,
    labelClassName: labelClasses,
    isLabelHidden: isLabelHidden,
    inputTag: InputTag
  }, otherProps)), /*#__PURE__*/React.createElement(FormMessage, {
    errorText: errorText,
    errorIconAriaLabel: errorIconAriaLabel,
    successText: successText,
    successIconAriaLabel: successIconAriaLabel,
    helperText: helperText,
    messageId: msgId,
    theme: _theme
  }), renderIcon(rightIcon, 'right'));
};

var _excluded$1 = ["inputClassName", "inputTag", "name", "id", "setFocus", "inputRef", "hasError", "placeholder", "placemat", "label", "labelClassName", "isLabelHidden"];

var overlayValue = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var mask = arguments.length > 1 ? arguments[1] : undefined;
  var vLen = value.length;
  var mLen = mask.length;

  if (vLen >= mLen) {
    return value;
  }

  return value.concat(mask.substring(vLen));
};

var Placemat = function (_ref) {
  var placeholder = _ref.placeholder,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value;
  var combinedText = overlayValue(value, placeholder);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_text-input__placemat']
  }, combinedText);
};

var TextInputContent = function (_ref2) {
  var inputClassName = _ref2.inputClassName,
      inputTag = _ref2.inputTag,
      name = _ref2.name,
      id = _ref2.id,
      setFocus = _ref2.setFocus,
      inputRef = _ref2.inputRef,
      hasError = _ref2.hasError,
      placeholder = _ref2.placeholder,
      placemat = _ref2.placemat,
      label = _ref2.label,
      labelClassName = _ref2.labelClassName,
      isLabelHidden = _ref2.isLabelHidden,
      rest = _objectWithoutProperties(_ref2, _excluded$1);

  // @ts-ignore
  var value = rest.value;
  var labelClasses = clsx(_defineProperty({}, styles['ppvx_text-input__label--screenreader'], isLabelHidden), labelClassName);
  useEffect(function () {
    var elem = inputRef.current;

    if (setFocus && elem) {
      elem.focus();
    }
  }, [setFocus]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!placemat && /*#__PURE__*/React.createElement(Placemat, {
    placeholder: placemat,
    value: value
  }), /*#__PURE__*/React.createElement(inputTag, _extends({
    className: inputClassName,
    name: name,
    id: id,
    ref: inputRef,
    "aria-invalid": hasError,
    placeholder: placeholder
  }, rest)), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    id: "".concat(id, "-label"),
    className: labelClasses
  }, label));
};

var _excluded$2 = ["label", "id", "prefix", "suffix", "prefixClassName", "suffixClassName", "inputClassName", "inputRef", "onBlur", "onFocus"];

var TextInputContentWithPrefixSuffix = function (_ref) {
  var label = _ref.label,
      id = _ref.id,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      prefixClassName = _ref.prefixClassName,
      suffixClassName = _ref.suffixClassName,
      inputClassName = _ref.inputClassName,
      inputRef = _ref.inputRef,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? null : _ref$onBlur,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? null : _ref$onFocus,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var textInputRef = inputRef;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      textInputHasFocus = _useState2[0],
      setTextInputFocus = _useState2[1];

  var inputClass = clsx(inputClassName, _defineProperty({}, styles['ppvx_text-input__control--prefix'], prefix), _defineProperty({}, styles['ppvx_text-input__control--suffix'], suffix));
  var PrefixClass = clsx(styles['ppvx_text-input__prefix'], prefixClassName);
  var SuffixClass = clsx(styles['ppvx_text-input__suffix'], suffixClassName);
  var prefixWrapperClass = clsx(styles['ppvx_text-input__prefix-wrapper'], _defineProperty({}, styles['ppvx_text-input__prefix-wrapper--focus'], textInputHasFocus));
  var labelId = label ? "".concat(id, "-label ") : '';
  var prefixEleId = prefix ? "".concat(id, "-prefix ") : '';
  var suffixEleId = suffix ? "".concat(id, "-suffix") : '';
  var ariaLabelledByIds = "".concat(labelId).concat(prefixEleId).concat(suffixEleId);
  return /*#__PURE__*/React.createElement("div", {
    className: prefixWrapperClass,
    onClick: function handlePrefixWrapperClick() {
      /* istanbul ignore else */
      if (textInputRef.current) {
        var textInputElm = textInputRef.current;
        textInputElm.focus();
      }
    }
  }, /*#__PURE__*/React.createElement(TextInputContent, _extends({
    label: label,
    id: id,
    inputClassName: inputClass,
    inputRef: inputRef,
    onFocus: function handleFocus(event) {
      setTextInputFocus(true);
      /* istanbul ignore else */

      if (onFocus) {
        onFocus(event);
      }
    },
    onBlur: function handleBlur(event) {
      setTextInputFocus(false);
      /* istanbul ignore else */

      if (onBlur) {
        onBlur(event);
      }
    },
    "aria-labelledby": ariaLabelledByIds.trim()
  }, rest)), prefix && /*#__PURE__*/React.createElement("div", {
    id: prefixEleId.trim(),
    className: PrefixClass
  }, prefix), suffix && /*#__PURE__*/React.createElement("div", {
    id: suffixEleId.trim(),
    className: SuffixClass
  }, suffix));
};

var _excluded$3 = ["prefix", "suffix", "prefixClassName", "suffixClassName"],
    _excluded2 = ["inputClassName", "name", "id", "setFocus", "hasError", "placeholder", "placemat", "label", "labelClassName", "inputTag"];
var TextInput = forwardRef(function (_ref, ref) {
  var prefix = _ref.prefix,
      suffix = _ref.suffix,
      prefixClassName = _ref.prefixClassName,
      suffixClassName = _ref.suffixClassName,
      props = _objectWithoutProperties(_ref, _excluded$3);

  var internalRef = useRef();
  var textInputRef = ref || internalRef;
  var theme = props.theme;

  var _theme = useTheme('TextInput', theme);

  if (_theme !== 'v2') {
    console.warn('Text Inputs 1.0 styles are deprecated. Use Text Inputs 2.0 styles and refer to our Migration Guide on how to use 2.0 styles/components.');
  }

  return /*#__PURE__*/React.createElement(TextInputWrapper, _extends({
    renderContent: function renderContent(_ref2) {
      var inputClassName = _ref2.inputClassName,
          name = _ref2.name,
          id = _ref2.id,
          setFocus = _ref2.setFocus,
          hasError = _ref2.hasError,
          placeholder = _ref2.placeholder,
          placemat = _ref2.placemat,
          label = _ref2.label,
          labelClassName = _ref2.labelClassName,
          inputTag = _ref2.inputTag,
          otherProps = _objectWithoutProperties(_ref2, _excluded2);

      if (prefix || suffix) {
        return /*#__PURE__*/React.createElement(TextInputContentWithPrefixSuffix, _extends({
          inputClassName: inputClassName,
          inputTag: inputTag,
          name: name,
          id: id,
          setFocus: setFocus,
          inputRef: textInputRef,
          hasError: hasError,
          placeholder: placeholder
          /*placemat={placemat}  placemat is currently not supported with prefix and suffix*/
          ,
          label: label,
          labelClassName: labelClassName,
          prefix: prefix,
          suffix: suffix,
          prefixClassName: prefixClassName,
          suffixClassName: suffixClassName
        }, otherProps));
      }

      return /*#__PURE__*/React.createElement(TextInputContent, _extends({
        inputClassName: inputClassName,
        inputTag: inputTag,
        name: name,
        id: id,
        setFocus: setFocus,
        inputRef: textInputRef,
        hasError: hasError,
        placeholder: placeholder,
        placemat: placemat,
        label: label,
        labelClassName: labelClassName
      }, otherProps));
    }
  }, props));
});

var _excluded$4 = ["className", "minRows", "maxRows", "showCharacterCounter", "maxCharacters", "counterStatusText", "onChange", "onBlur", "onFocus", "value"],
    _excluded2$1 = ["inputClassName", "name", "id", "setFocus", "hasError", "placeholder", "label", "labelClassName", "inputTag", "placemat"];
var MIN_ROWS = 2;
var MAX_ROWS = 6;
var DEFAULT_LINE_HEIGHT = 24;
var TextArea = forwardRef(function (_ref, ref) {
  var className = _ref.className,
      _ref$minRows = _ref.minRows,
      minRows = _ref$minRows === void 0 ? MIN_ROWS : _ref$minRows,
      _ref$maxRows = _ref.maxRows,
      maxRows = _ref$maxRows === void 0 ? MAX_ROWS : _ref$maxRows,
      _ref$showCharacterCou = _ref.showCharacterCounter,
      showCharacterCounter = _ref$showCharacterCou === void 0 ? false : _ref$showCharacterCou,
      maxCharacters = _ref.maxCharacters,
      counterStatusText = _ref.counterStatusText,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? null : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? null : _ref$onBlur,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? null : _ref$onFocus,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded$4);

  var baseCls = clsx(styles['ppvx_text-input--auto-grow'], className);
  var maxAllowedRows = maxRows ? Math.max(maxRows, MIN_ROWS) : MAX_ROWS;
  var minAllowedRows = minRows ? Math.max(minRows, MIN_ROWS) : MIN_ROWS;

  var _useState = useState(value ? value.length : 0),
      _useState2 = _slicedToArray(_useState, 2),
      charCount = _useState2[0],
      setCharCount = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isRTL = _useState4[0],
      setRTL = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      textAreaHasFocus = _useState6[0],
      setTextAreaFocus = _useState6[1];

  var internalRef = useRef();
  var textAreaRef = ref || internalRef;
  var intlContext = useContext(IntlContext);
  var theme = rest.theme;

  var _theme = useTheme('TextInput', theme);
  /* istanbul ignore next */


  if (_theme !== 'v2') {
    console.warn('Text Area 1.0 styles are deprecated. Use Text Area 2.0 styles and refer to our Migration Guide on how to use 2.0 styles/components.');
  }

  var bordersOffset = useRef(0);
  var maxHeight = useRef(DEFAULT_LINE_HEIGHT * maxAllowedRows);
  var minHeight = useRef(DEFAULT_LINE_HEIGHT * minAllowedRows);

  var computeHeight = function () {
    var textAreaElm = textAreaRef.current; // eslint-disable-next-line

    textAreaElm.style.height = 'auto';
    var newHeight = textAreaElm.scrollHeight + bordersOffset.current;
    /* istanbul ignore next */

    if (newHeight > maxHeight.current) {
      textAreaElm.style.height = "".concat(maxHeight.current, "px");
    } else if (newHeight > minHeight.current) {
      textAreaElm.style.height = "".concat(newHeight, "px");
    } else {
      textAreaElm.style.height = "".concat(minHeight.current, "px");
    }
  };

  useEffect(function () {
    /* istanbul ignore next */
    if (textAreaRef.current) {
      var textAreaElm = textAreaRef.current;
      var offsetHeight = textAreaElm.offsetHeight,
          clientHeight = textAreaElm.clientHeight;
      var computedStyle = window.getComputedStyle(textAreaElm);
      var lineHeightValue = Number(computedStyle.getPropertyValue('line-height').split('px')[0]);
      var paddingBottomValue = Number(computedStyle.getPropertyValue('padding-bottom').split('px')[0]);
      var paddingTopValue = Number(computedStyle.getPropertyValue('padding-top').split('px')[0]);
      var lineHeight = Number.isNaN(lineHeightValue) ? DEFAULT_LINE_HEIGHT : lineHeightValue;
      var paddingBottom = Number.isNaN(paddingBottomValue) ? 0 : paddingBottomValue;
      var paddingTop = Number.isNaN(paddingTopValue) ? 0 : paddingTopValue;
      bordersOffset.current = offsetHeight - clientHeight;
      maxHeight.current = bordersOffset.current + paddingTop + paddingBottom + lineHeight * maxAllowedRows;
      minHeight.current = bordersOffset.current + paddingTop + paddingBottom + lineHeight * minAllowedRows;
      computeHeight();
      setRTL(computedStyle.direction === 'rtl');
    }
  }, [minAllowedRows, maxAllowedRows, value]);

  var handleCounterWrapperClick = function () {
    /* istanbul ignore else */
    if (textAreaRef.current) {
      var textAreaElm = textAreaRef.current;
      textAreaElm.focus();
    }
  };

  return /*#__PURE__*/React.createElement(TextInputWrapper, _extends({
    className: baseCls,
    value: value,
    onChange: function handleChange(event) {
      var textAreaElm = event.target;
      setCharCount(textAreaElm.value.length);
      /* istanbul ignore else */

      if (onChange) {
        onChange(event);
      }
    },
    onFocus: function handleFocus(event) {
      setTextAreaFocus(true);
      /* istanbul ignore else */

      if (onFocus) {
        onFocus(event);
      }
    },
    onBlur: function handleBlur(event) {
      setTextAreaFocus(false);
      /* istanbul ignore else */

      if (onBlur) {
        onBlur(event);
      }
    },
    renderContent: function renderContent(_ref2) {
      var inputClassName = _ref2.inputClassName,
          name = _ref2.name,
          id = _ref2.id,
          setFocus = _ref2.setFocus,
          hasError = _ref2.hasError,
          placeholder = _ref2.placeholder,
          label = _ref2.label,
          labelClassName = _ref2.labelClassName,
          inputTag = _ref2.inputTag,
          placemat = _ref2.placemat,
          otherProps = _objectWithoutProperties(_ref2, _excluded2$1);

      var textInputContent = /*#__PURE__*/React.createElement(TextInputContent, _extends({
        inputClassName: inputClassName,
        inputTag: "textarea",
        name: name,
        id: id,
        setFocus: setFocus,
        inputRef: textAreaRef,
        hasError: hasError,
        placeholder: placeholder,
        label: label,
        labelClassName: labelClassName
      }, otherProps));

      if (showCharacterCounter) {
        var maxCharsText = '';

        if (maxCharacters) {
          maxCharsText = isRTL ? "".concat(maxCharacters, "/") : "/".concat(maxCharacters);
        }

        var counterText = isRTL ? "".concat(maxCharsText).concat(charCount) : "".concat(charCount).concat(maxCharsText);
        var counterStatusMessage = getFormattedMessage(intlContext, "".concat(charCount, " out of ").concat(maxCharacters, " characters used"), counterStatusText, {
          charCount: charCount,
          maxCharacters: maxCharacters
        });
        var wrapperCls = clsx(styles['ppvx_text-input__counter-wrapper'], textAreaHasFocus && styles['ppvx_text-input__counter-wrapper--focus']);
        return /*#__PURE__*/React.createElement("div", {
          className: wrapperCls,
          onClick: handleCounterWrapperClick
        }, textInputContent, /*#__PURE__*/React.createElement("div", {
          className: styles['ppvx_text-input__counter-text'],
          role: "status",
          "aria-live": "polite",
          "aria-atomic": "true",
          "aria-label": counterStatusMessage
        }, counterText));
      }

      return textInputContent;
    }
  }, rest));
});

var _excluded$5 = ["className", "valueClassName", "labelClassName", "name", "id", "label", "value", "rightIcon", "helperText", "isLabelHidden"];

var TextDisplay = function (_ref) {
  var className = _ref.className,
      valueClassName = _ref.valueClassName,
      labelClassName = _ref.labelClassName,
      name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      value = _ref.value,
      rightIcon = _ref.rightIcon,
      helperText = _ref.helperText,
      isLabelHidden = _ref.isLabelHidden,
      rest = _objectWithoutProperties(_ref, _excluded$5);

  var containerClasses = clsx(styles['ppvx_text-input-display'], className);
  var controlClasses = clsx(styles['ppvx_text-input__control'], styles['ppvx_text-input-display__control'], _defineProperty({}, styles['ppvx_text-input__control--icon-right'], rightIcon), valueClassName);
  var labelClasses = clsx(styles['ppvx_text-input__label'], styles['ppvx_text-input-display__label'], _defineProperty({}, styles['ppvx_text-input__label--screenreader'], isLabelHidden), labelClassName);
  var labelId = "txtDsplyLbl_".concat(name);
  var valueId = "txtDsplyVlu_".concat(name);
  return /*#__PURE__*/React.createElement(TextInputWrapper, _extends({
    theme: "v2",
    className: containerClasses,
    label: label,
    name: name,
    isLabelHidden: isLabelHidden,
    helperText: helperText,
    renderContent: function renderContent() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles['ppvx_text-input-display__wrapper'],
        "aria-labelledby": "".concat(labelId, " ").concat(valueId),
        id: id
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: name,
        value: value
      }), /*#__PURE__*/React.createElement("span", {
        className: controlClasses,
        id: valueId
      }, value), /*#__PURE__*/React.createElement("span", {
        className: labelClasses,
        id: labelId
      }, label));
    },
    rightIcon: rightIcon
  }, rest));
};

export { TextArea, TextDisplay, TextInput };
